// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"83ddbf66","239":"821052ce","455":"ad1d130e"}[chunkId] + ".chunk.js";
};